import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TransportationService', TransportationService);

  TransportationService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TransportationModalService',
    'WindowModalService',
    'SessionService',
  ];

  function TransportationService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TransportationModalService,
    WindowModalService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'transportations';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getTransportations: getTransportations,
      getTransportation: getTransportation,
      saveTransportation: saveTransportation,
      deleteTransportation: deleteTransportation,
      changeTransportationStatus: changeTransportationStatus,
      changeTransportationFeatured: changeTransportationFeatured,
      openTransportationRoutePointsMapModal: openTransportationRoutePointsMapModal,
      openTransportationListModal: openTransportationListModal,

      setDefaultAssociatedProvider: setDefaultAssociatedProvider,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getTransportations(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getTransportation(id, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveTransportation(item) {
      var method = 'post';

      var url = apiUrl;
      if (item.id) {
        // edit
        url += '/' + item.id;
        method = 'put';
      }

      function success(response) {
        var msg = !item.id ? 'TRANSPORTATION_ADDED' : 'TRANSPORTATION_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { transportation: item }, success, failure);
    }

    function deleteTransportation(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_TRANSPORTATION',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'TRANSPORTATION_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeTransportationStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeTransportationFeatured(item) {
      utils.changeItemFeatured(apiUrl + '/' + item.id, item);
    }

    function openTransportationRoutePointsMapModal(item) {
      var templateUrl = './app/ajs/transportation/modals/transportation-route-points-modal.html';

      var modalParams = {
        title: 'ROUTE_POINTS',
        item: item,
      };

      // var confirmCallback = function(selectedItem) {
      //return getItemsCallback(selectedItem);
      // };

      WindowModalService.open(templateUrl, modalParams, {});
    }

    function openTransportationListModal(transportationIds, websiteId) {
      TransportationModalService.openTransportationListModal(transportationIds, websiteId);
    }

    function setDefaultAssociatedProvider(providerId, transportationId, successCallback) {
      var url = apiUrl + '/' + transportationId + '/set_default_associated_provider';

      return RestResource.request(
        'put',
        url,
        { provider_id: providerId },
        function (response) {
          var msg = $translate('DEFAULT_PROVIDER_CHANGED');
          utils._successMsg(msg);

          return successCallback(providerId);
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }
  }
})();
